import * as React from "react"
import { cn } from "../../lib/utils"

const Accordion = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={cn("space-y-2", className)} {...props}>
      {children}
    </div>
  )
})

Accordion.displayName = "Accordion"

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn("border border-gray-200 rounded-lg", className)}
      {...props}
    />
  )
})

AccordionItem.displayName = "AccordionItem"

const AccordionTrigger = React.forwardRef(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "flex w-full items-center justify-between p-4 font-medium transition-all hover:bg-gray-50",
          className
        )}
        {...props}
      >
        {children}
      </button>
    )
  }
)

AccordionTrigger.displayName = "AccordionTrigger"

const AccordionContent = React.forwardRef(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("px-4 pb-4 pt-0 text-sm", className)}
        {...props}
      >
        {children}
      </div>
    )
  }
)

AccordionContent.displayName = "AccordionContent"

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
